<div class="container">

	<div class="portalCard">

		<div class="rowScreenColPhone">

			<div class="aTitle">
				<mat-icon>close_fullscreen</mat-icon>
				<span>Austausch</span>
			</div>

			<button
				mat-raised-button
				color="primary"
				[disabled]="bInProgress"
				routerLink="./Erstellen"
			>
				+ Erstellung
			</button>

		</div>

		<div>

			@if( bFirstLoading ) {
				<mat-progress-bar mode="indeterminate" />
			}
			@else if( bLoadingError ) {
				<h4 style="text-align: center; color: red;">
					Beim Laden der Dokumente ist ein Fehler aufgetreten
				</h4>
			}
			@else if( bNoCategories ) {
				<div class="hintEmptyCategories noElements" style="text-align: center;">
					<span>Es wurden keine Austauschkategorien für Sie hinterlegt.</span>
				</div>
			}
			<!--
			@else if( !documentExchanges.length ) {
				<h4 style="text-align: center">
					Kein Austausch vorhanden
				</h4>
			}
			-->
			@else {

				<div class="mainPanel">

					<div class="labelPanel">
						Filter
					</div>

					<div
						class="filterElements"
						[formGroup]="filterFormGroup"
					>

						<mat-form-field appearance="outline" subscriptSizing="dynamic">

							<mat-label>Eingehend / Ausgehend</mat-label>

							<mat-select formControlName="incomingOutgoing">

								<mat-option value="all">
									Alle
								</mat-option>
								<mat-option value="in">
									Eingehend
								</mat-option>
								<mat-option value="out">
									Ausgehend
								</mat-option>

							</mat-select>

						</mat-form-field>

						@if( bAdmin ) {

							<misc-combobox
								[elements]="membersCombo"
								placeholder="Mitglied"
								(onSelected)="onMemberSelected($event)"
								[bAllOption]="true"
							/>

						}

						<chips-autocomplete
							[allElems]="categoryChips"
							label="Kategorien"
							(newValue)="onNewCategoryFilter($event)"
						/>
						
						<mat-form-field appearance="outline" subscriptSizing="dynamic" class="matformfield-date">

							<mat-label>Anfangsdatum</mat-label>

							<input
								matInput
								[matDatepicker]="pickerStart"
								formControlName="dateStart"
							>

							<div
								matSuffix
								style="display: flex; flex-flow: row nowrap; gap: 0em"
							>
								<button
									*ngIf="filterFormGroup.get('dateStart')?.value"
									mat-icon-button
									(click)="filterFormGroup.get('dateStart')?.reset()"
								>
									<mat-icon>clear</mat-icon>
								</button>
								<mat-datepicker-toggle [for]="pickerStart"></mat-datepicker-toggle>
							</div>

							<mat-datepicker #pickerStart></mat-datepicker>

						</mat-form-field>

						<mat-form-field appearance="outline" subscriptSizing="dynamic" class="matformfield-date">

							<mat-label>Enddatum</mat-label>

							<input
								matInput
								[matDatepicker]="pickerEnd"
								formControlName="dateEnd"
							>

							<div
								matSuffix
								style="display: flex; flex-flow: row nowrap; gap: 0em"
							>
								<button
									*ngIf="filterFormGroup.get('dateEnd')?.value"
									mat-icon-button
									(click)="filterFormGroup.get('dateEnd')?.reset()"
								>
									<mat-icon>clear</mat-icon>
								</button>
								<mat-datepicker-toggle [for]="pickerEnd"></mat-datepicker-toggle>
							</div>

							<mat-datepicker #pickerEnd></mat-datepicker>

						</mat-form-field>

						<mat-form-field
							appearance="outline"
							subscriptSizing="dynamic"
							style="flex-grow: 2;"
						>

							<mat-label>Beschreibung</mat-label>

							<input
								matInput
								formControlName="description"
							>

						</mat-form-field>

					</div>

					<div class="labelPanel">
						Ereignisse
					</div>
	
					<div class="resultElements">

						<div class="tableHolder">
							<table>
	
								<thead>

									<tr>

										<th
											class="tdArrow"
											title="Eingehend / Ausgehend"
										>
											E/A
										</th>

										@if( bAdmin ) {

											<th>
												Mitglied
												<!--
												(click)="clickSort('sender_id')"
												@if( sortingField == 'sender_id' ) {
													@if( sortingAsc ) {
														<span class="material-icons">arrow_drop_down</span>
													}
													@else {
														<span class="material-icons">arrow_drop_up</span>
													}
												}
												-->
											</th>

										}

										<th>Kategorie</th>
										<th>Beschreibung</th>
										<th>Anhänge</th>
										<th>Datum</th>
										<th>Gelesen am</th>
										<th></th>

									</tr>

								</thead>
	
								<tbody>
								
									@for( documentExchange of documentExchanges; track documentExchange.id ) {

										<tr [class.unread]="!documentExchange.bSeen">
											
											<td class="tdArrow">

												@if(  ( bAdmin && !documentExchange.anMitglied ) || ( !bAdmin && documentExchange.anMitglied )  ) {
													<span
														class="material-icons"
														title="Eingehend"
														style="color: var(--mainColor)"
													>arrow_downward</span>
												}
												@else {
													<span
														class="material-icons"
														title="Ausgehend"
														style="color: darkslateblue"
													>arrow_upward</span>
												}

											</td>

											@if( bAdmin ) {
												<td
													[style.cursor]="documentExchange.bOwn ? 'pointer' : 'initial'"
													(click)="clickToggleViewedStatus(documentExchange)"
												>
													@if(  ( bAdmin && !documentExchange.anMitglied ) || ( !bAdmin && documentExchange.anMitglied )  ) {
														{{ memberNames[ documentExchange.memberSenderId ] || documentExchange.memberSenderId }}
													}
													@else {
														{{ memberNames[ documentExchange.memberRecipientId ] || documentExchange.memberRecipientId }}
													}
												</td>
											}
											<td
												[style.cursor]="documentExchange.bOwn ? 'pointer' : 'initial'"
												(click)="clickToggleViewedStatus(documentExchange)"
											>
												<!-- {{ documentExchangeCategoryNames[ documentExchange.category ] || '' }} -->
												{{documentExchange.categoryName}}
											</td>
											<td
												[style.cursor]="documentExchange.bOwn ? 'pointer' : 'initial'"
												(click)="clickToggleViewedStatus(documentExchange)"
											>
												{{documentExchange.description}}
											</td>
											<td>
												@for( f of documentExchange.files; track f.id ) {
													<div>
														<span
															class="fileLink"
															(click)="downloadFile( f, documentExchange )"
														>
															{{f.filename}}
														</span>
													</div>
												}
											</td>
											<td
												[style.cursor]="documentExchange.bOwn ? 'pointer' : 'initial'"
												(click)="clickToggleViewedStatus(documentExchange)"
											>
												@if( documentExchange.date !== null ) {
													{{documentExchange.date | date}}
												}
											</td>
											<td
												[style.cursor]="documentExchange.bOwn ? 'pointer' : 'initial'"
												(click)="clickToggleViewedStatus(documentExchange)"
											>
												@if( documentExchange.dateFirstRead !== null ) {
													{{documentExchange.dateFirstRead | date}}
												}
											</td>
											<td>
												<div class="actionIcons">

													@if( documentExchange.bSeen ) {

														@if( bTogglingViewed[ documentExchange.id ] ) {
															<span
																class="material-icons pending"
																title="in Bearbeitung"
															>visibility</span>
														}
														@else if( documentExchange.bOwn ) {
															<span
																class="material-icons iconBtn"
																title="Zu „ungelesen“ wechseln"
																style="opacity: .5;"
																(click)="clickSwitchViewedStatus( documentExchange, false )"
															>visibility</span>
														}
														@else {
															<span
																class="material-icons"
																title="Gelesen"
																style="opacity: .5;"
															>visibility</span>
														}

													}
													@else {

														@if( bTogglingViewed[ documentExchange.id ] ) {
															<span
																class="material-icons pending"
																title="in Bearbeitung"
															>visibility_off</span>
														}
														@else if( documentExchange.bOwn ) {
															<span
																class="material-icons iconBtn"
																title="Zu „gelesen“ wechseln"
																(click)="clickSwitchViewedStatus( documentExchange, true )"
															>visibility_off</span>
														}
														@else {
															<span
																class="material-icons"
																title="Ungelesen"
															>visibility_off</span>
														}

													}

													@if( bDeleting[ documentExchange.id ] ) {
														<span
															class="material-icons pending"
															title="in Bearbeitung"
														>delete_forever</span>
													}
													@else if( bAdmin ) {
														<span
															class="material-icons iconBtn"
															[title]="'Löschen \'' + documentExchange.description + '\''"
															(click)="clickDelete(documentExchange)"
														>delete_forever</span>
													}

												</div>
											</td>
										</tr>

									}

									@if( !documentExchanges.length ) {

										<tr class="noExchange">
											<td
												colspan="8"
												style="font-size: large; padding: 4em 0; text-align: center;"
												class="noElements"
											>
												<span class="noExchangeLabel">Kein Austausch vorhanden</span>
											</td>
										</tr>

									}
	
								</tbody>
	
							</table>
						</div>

						<mat-paginator
							style="background-color: transparent;"
							(page)="handlePageEvent($event)"
							[length]="totalNb"
							[pageSize]="10"
							[showFirstLastButtons]="true"
						/>

						@if( bSearching ) {
							<mat-progress-bar mode="indeterminate" />
						}
					
					</div>

				</div>

			}

		</div>

	</div>

</div>
